/**
 * DomainSummaryBanner — domain-level AI summary, styled like AISummaryBanner
 * but showing aggregated insights across all emails in a domain.
 */
import React, { useState } from 'react';
import { Sparkles, ChevronDown, ChevronUp } from 'lucide-react';
import { cn, ICON_PX } from '../../../ui';

function DomainSummaryBanner({ summary, className }) {
  const [expanded, setExpanded] = useState(true);

  if (!summary) return null;

  return (
    <div className={cn(
      'rounded-lg border border-aqua/20 bg-aqua-glow/5 overflow-hidden',
      className,
    )}>
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-aqua-glow/10 transition-colors"
      >
        <Sparkles size={ICON_PX.md} style={{ color: 'var(--aqua)' }} className="shrink-0" />
        <span className="text-body-sm font-semibold text-aqua flex-1 min-w-0">AI Domain Summary</span>
        {expanded
          ? <ChevronUp size={ICON_PX.sm} className="text-text-muted shrink-0" />
          : <ChevronDown size={ICON_PX.sm} className="text-text-muted shrink-0" />
        }
      </button>
      {expanded && (
        <div className="px-3 pb-2.5 text-body-sm text-text-dark leading-relaxed">
          {summary}
        </div>
      )}
    </div>
  );
}

export { DomainSummaryBanner };
